"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "WindowSizeProvider", {
  enumerable: true,
  get: function get() {
    return _useWindowSize.WindowSizeProvider;
  }
});
Object.defineProperty(exports, "useWindowSize", {
  enumerable: true,
  get: function get() {
    return _useWindowSize.useWindowSize;
  }
});

var _useWindowSize = require("./hooks/useWindowSize");